:host {
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: subgrid;
	top: var(--top);
	position: sticky;
	z-index: var(--z-index);
	--smoothly-color: var(--smoothly-table-header-background);
	--smoothly-color-contrast: var(--smoothly-table-header-foreground);
	background-color: rgb(var(--smoothly-table-header-background));
	color: rgb(var(--smoothly-table-header-foreground));
	stroke: rgb(var(--smoothly-table-header-foreground));
	fill: rgb(var(--smoothly-table-header-foreground));
	font-weight: bold;
	transition: box-shadow 0.3s ease;
}

:host.scrolled {
	box-shadow: var(--smoothly-table-header-shadow);
}
